import FilterLoading from './filter.component';

export default FilterLoading;